import Products from './ProductsController';

export default Products;
